import { useEffect, useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Plumbing } from "@/components/Plumbing";
import { NewBoiler } from "@/components/NewBoiler";
import { Booking } from "@/components/Booking";
import { Quote } from "@/components/Quote";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Coverage } from "@/components/Coverage";
import { Landlords } from "@/components/Landlords";
import { Blog } from "@/components/Blog";
import { Faq } from "@/components/Faq";
import { HowItWorks } from "@/components/HowItWorks";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { StickyCTA } from "@/components/StickyCTA";

export default function Home() {
  const [preselected, setPreselected] = useState(null);

  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => {
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return () => clearTimeout(t);
    }
  }, []);

  const handleBookService = (serviceId) => {
    setPreselected(serviceId);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="bg-obsidian text-neutral-100 overflow-x-clip">
      <Nav />
      <main>
        <Hero onBook={() => handleBookService("boiler_service")} />
        <Marquee />
        <Services onBook={handleBookService} />
        <NewBoiler />
        <Plumbing />
        <HowItWorks />
        <Booking preselected={preselected} />
        <Quote />
        <Manifesto />
        <Gallery />
        <Reviews />
        <Landlords onBook={handleBookService} />
        <Blog />
        <Faq />
        <Coverage />
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
      <StickyCTA />
    </div>
  );
}
